/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminWorkerJob,
    AdminWorkerJobFromJSON,
    AdminWorkerJobFromJSONTyped,
    AdminWorkerJobToJSON,
} from './AdminWorkerJob';

/**
 * 
 * @export
 * @interface AdminWorkerJobsResp
 */
export interface AdminWorkerJobsResp {
    /**
     * 
     * @type {Array<AdminWorkerJob>}
     * @memberof AdminWorkerJobsResp
     */
    items: Array<AdminWorkerJob>;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerJobsResp
     */
    total: number;
}

export function AdminWorkerJobsRespFromJSON(json: any): AdminWorkerJobsResp {
    return AdminWorkerJobsRespFromJSONTyped(json, false);
}

export function AdminWorkerJobsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerJobsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AdminWorkerJobFromJSON)),
        'total': json['total'],
    };
}

export function AdminWorkerJobsRespToJSON(value?: AdminWorkerJobsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(AdminWorkerJobToJSON)),
        'total': value.total,
    };
}

